<template>
  <div class="scoring-component">

    <div class="score-numbers">
      <div
        v-for="num in scoreRange"
        :key="num"
        class="number-item"
        :class="{ active: value === num, disabled: disabled }"
        @click="handleSelect(num)"
      >
        {{ num }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ScoringComponent",
  props: {
    value: {
      type: Number,
      default: null,
    },
    label: {
      type: String,
      default: "",
    },
    maxScore: {
      type: Number,
      default: 10,
    },
    minScore: {
      type: Number,
      default: 1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    scoreRange() {
      const range = [];
      for (let i = this.minScore; i <= this.maxScore; i++) {
        range.push(i);
      }
      return range;
    },
    labelWidth() {
      const itemWidth = 35;
      const marginRight = 3;
      return (this.maxScore - this.minScore + 1) * itemWidth + (this.maxScore - this.minScore) * marginRight;
    },
  },
  methods: {
    handleSelect(num) {
      if (this.disabled) return;
      this.$emit("input", num);
    },
  },
};
</script>

<style scoped lang="scss">
.score-range {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 12px;
  color: #999;
  margin-bottom: 5px;
}
.left {
  margin-left: 5px;
}
.right {
  margin-right: 5px;
}
.scoring-component {
  width: 100%;
  max-width: 400px;
  padding: 10px 0;
}

.score-numbers {
  display: flex;
  margin-bottom: 3px;
}

.number-item {
  width: 35px;
  height: 41px;
  background: #f1f5fa;
  border-radius: 0px 0px 0px 0px;
  line-height: 41px;
  text-align: center;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 12px;
  color: #2f86ff;
  cursor: pointer;
  margin-right: 3px;
  &:last-child {
    margin-right: 0;
  }
  &.active {
    background: #2f86ff;
    border-color: #2f86ff;
    color: #fff;
  }
}

.score-labels {
  display: flex;
  justify-content: space-between;
}

.label-item {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 12px;
  color: #c2c2c2;
}
</style>
